import React, { Component } from 'react';
import { connect } from 'react-redux';
import {CSSTransition,TransitionGroup} from 'react-transition-group';

import { configure, getConfiguration } from '../../actions/Settings'
import { submitConnectForm } from '../../actions/Groups'

import ConnectForm from './ConnectForm'
import Spinner from '../Spinner';

class TCCPrayerRequests extends Component {

    constructor(props){
        super(props);
        this.state = {
            showForm: true,
            nonce: props.nonce,
            postid: props.postid
        }
    }

    componentDidMount(){
        this.props.configure(this.props.site);
        this.props.getConfiguration();
    }

    handleSubmit = (args) => {
        const body = {...args};
        body.nonce = this.props.nonce;
        body.post_id = this.props.postid;
        this.props.submitConnectForm(body)
        this.setState({showForm:false});
    }

    render(){
        return(<div className="TCCGroupsForm">

            <TransitionGroup>
                {(this.state.showForm && (
                    <CSSTransition key={1} timeout={200} classNames="form-transition">
                        <div className="groups-form-wrap tcc-webcomponent-form-wrap">
                            <ConnectForm onSubmit={(values) => this.handleSubmit(values)} />
                        </div>
                    </CSSTransition>
                ))}
            </TransitionGroup>

            {(this.props.uiLoading === 'success' && (
                <div className="success"><span className="icon-check"></span></div>
            ))}

            {(this.props.uiLoading === 'loading' && (
                <Spinner />
            ))}

        </div>)
    }
}
const mapStateToProps = state => ({
    settings: state.Settings,
    uiLoading: state.Groups.ui
})

const mapDispatchToProps = dispatch => ({
    configure: (site) => dispatch(configure(site)),
    getConfiguration: () => dispatch(getConfiguration()),
    submitConnectForm: (args) => dispatch(submitConnectForm(args)),
})

export default connect(mapStateToProps, mapDispatchToProps)(TCCPrayerRequests);
